import TableChart from "@mui/icons-material/TableChart";
import { Typography, useTheme } from "@mui/material";
import { FormattedMessage } from "react-intl";
import type { To } from "react-router";

import type { TranslationID } from "@citrine/lang/utils";
import type { BranchNodeType } from "@citrine/resources/branch";

import { NodeIcon } from "#src/components/node-icon";

import * as sx from "./project-step.sx";

export interface ProjectStepProps {
  nodeType: BranchNodeType;
  titleId: TranslationID;
  to: To;
}

export function ProjectStep({ nodeType, titleId, to }: ProjectStepProps) {
  const theme = useTheme();

  const content = (
    <>
      <sx.Title>
        {nodeType === "data" ? (
          <TableChart fontSize="small" htmlColor={theme.palette.data.main} />
        ) : (
          <NodeIcon type={nodeType} fontSize="small" />
        )}
        <Typography sx={{ textTransform: "uppercase" }}>
          <FormattedMessage id={titleId} />
        </Typography>
      </sx.Title>
    </>
  );

  return (
    <sx.Step
      as={to ? undefined : "div"}
      data-testid={`${nodeType}-step`}
      to={to}
    >
      {content}
    </sx.Step>
  );
}
